import React from "react";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { BsChatLeftTextFill } from "react-icons/bs";
import { HiMiniShoppingBag } from "react-icons/hi2";
import { BsClipboard2MinusFill } from "react-icons/bs";
import { Link } from "react-router-dom";

const CardTotal = ({ type, title, number, explaination, link }) => {
  const icons = {
    1: <BsClipboard2MinusFill className="w-7 h-7" />,
    2: <HiOutlineDocumentReport className="w-7 h-7" />,
    3: <HiMiniShoppingBag className="w-7 h-7" />,
  };

  const textColors = {
    1: "text-[#634C05]",
    2: "text-[#051F33]",
    3: "text-[#662800]",
  };
  const CardColors = {
    1: "bg-[#FFE9A6]",
    2: "bg-[#ADD3F2]",
    3: "bg-[#FFDAC2]",
  };

  const content = (
    <div
      className={`flex flex-col justify-between h-32 gap-5 font-inter p-6 rounded-2xl shadow-lg transition duration-300 ${
        link ? "hover:shadow-2xl hover:-translate-y-1 cursor-pointer" : ""
      } ${CardColors[type] || "text-gray-700"}`}
    >
      <div
        className={`flex gap-3 items-center ${
          textColors[type] || "text-gray-700"
        }`}
      >
        {icons[type] || <HiOutlineDocumentReport className="w-7 h-7" />}

        <p className="font-semibold text-xl">{title}</p>
      </div>

      <div className="flex items-baseline gap-3">
        <p
          className={`text-4xl font-semibold ${
            textColors[type] || "text-gray-700"
          } `}
        >
          {number}
        </p>
        <span className="text-[#8d7b6f] font-medium text-lg">
          {explaination}
        </span>
      </div>
    </div>
  );

  if (link) {
    return <Link to={link}>{content}</Link>;
  }

  return content;
};

export default CardTotal;